/**
 * Canonical salesperson list — single source for QuoteForm's dropdown,
 * Search's quote filter, and the audit trail's ID→name display.
 * (Previously duplicated inline in QuoteForm.jsx and Search.jsx.)
 */
export const salespersonList = [
  { EmployeeID: 1, EmployeeName: "Terry James" },
  { EmployeeID: 5, EmployeeName: "Kevin Hlavac" },
  { EmployeeID: 12, EmployeeName: "Jason Dickey" },
  { EmployeeID: 30, EmployeeName: "Scott Gardner" },
  { EmployeeID: 31, EmployeeName: "Felix Gardner" },
  { EmployeeID: 60, EmployeeName: "Matt Whitacre" },
  { EmployeeID: 219, EmployeeName: "Melissa Fonzo" },
  { EmployeeID: 220, EmployeeName: "Jessee Avery" },
];

/** "31" -> "31 | Felix Gardner"; 0/blank -> "—"; unknown ids pass through. */
export function formatSalesperson(id) {
  if (id === null || id === undefined || id === "" || Number(id) === 0)
    return "—";
  const match = salespersonList.find(
    (s) => String(s.EmployeeID) === String(id),
  );
  return match ? `${match.EmployeeID} | ${match.EmployeeName}` : String(id);
}
